<template>
    <div>
        <br/>
        <div class="table-responsive">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <multiselect
                            class="form-control border-0"
                            v-model="search.seller"
                            :options="optionSeller"
                            track-by="id"
                            :customLabel="saleWithLabel"
                            :show-labels="false"
                            placeholder="เลือกเซลล์">
                        </multiselect>
                        <multiselect
                            v-model="search.customer"
                            class="form-control border-0"
                            :options="optionCustomer"
                            :customLabel="customerWithLabel"
                            placeholder="ค้นหาลูกค้า"
                            :show-labels="false"
                            track-by="id">
                        </multiselect>
                        <date-picker v-model="search.date"
                                     range
                                     placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"
                                     :format="changeFormat"
                                     :lang="lang" confirm>
                        </date-picker>
                        &nbsp;&nbsp;
                        <button class="btn btn-success"
                                @click="searchGiftData"
                                type="button">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>
                        &nbsp;&nbsp;
                        <button class="btn btn-primary"
                                type="button"
                                @click="printGiftReport">
                            <icon name="print"></icon>
                            พิมพ์ข้อมูลประเภทของขวัญ
                        </button>
                        &nbsp;&nbsp;
                    </form>
                </div>
            </nav>
            <div style="min-height: 300px">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">รหัสเซลล์</th>
                        <th scope="col">เซลล์</th>
                        <th scope="col">รหัสลูกค้า</th>
                        <th scope="col">ลูกค้า</th>
                        <th scope="col">ชื่อ / รหัสสินค้า</th>
                        <th scope="col">จำนวน</th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="data in exampleGiftList" v-if="data.customer_code">
                        <tr v-for="item in data.details">
                            <td>{{ item.sale_id }}</td>
                            <td>{{ item.sale_name }}</td>
                            <td>{{ item.customer_code }}</td>
                            <td>{{ item.customer_name }}</td>
                            <td>{{ item.product_name }}</td>
                            <td>{{ item.quantity |amount }}</td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
        </div>
        <!--        <pre class="alert-danger">{{exampleGiftList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex";
import Multiselect from "vue-multiselect";
import {domain} from "../../../util/Constants";
import DatePicker from 'vue2-datepicker'
import moment from "moment";

export default {
    name: "example-gift-list",
    components: {
        Multiselect, DatePicker
    },
    data() {
        return {
            search: {
                seller: null,
                customer: null,
                date: [],
            },
            optionCustomer: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    created() {
        this.getCustomerAll();
        this.getGiftData();
    },
    computed: {
        ...mapState({
            exampleGiftList: state => {
                return state.ExampleGift.example_gift_list;
            },
            optionSeller: state => {
                return state.Seller.data;
            }
        })
    },
    methods: {
        saleWithLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        customerWithLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(customers => {
                this.optionCustomer = customers;
            });
        },
        getGiftData() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            let data = {
                start_date,
                end_date,
                customer_id,
                seller_id
            }
            this.$store.dispatch("ExampleGift/setExampleGift", data);
        },
        searchGiftData() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            if (this.search.seller) {
                seller_id = this.search.seller.id;
            }
            if (this.search.customer) {
                customer_id = this.search.customer.id;
            }
            let data = {
                start_date,
                end_date,
                customer_id,
                seller_id
            }
            this.$store.dispatch("ExampleGift/setExampleGift", data);
        },
        printGiftReport() {
            let start_date = '';
            let end_date = '';
            let customer_id = '';
            let seller_id = '';
            if (this.search.date.length > 0) {
                start_date = moment(this.search.date[0]).format("YYYY-MM-DD");
                end_date = moment(this.search.date[1]).format("YYYY-MM-DD");
            }
            if (this.search.seller) {
                seller_id = this.search.seller.id;
            }
            if (this.search.customer) {
                customer_id = this.search.customer.id;
            }
            window.open(`${domain}/example_gift_report?seller_id=${seller_id}` +
                `&customer_id=${customer_id}` +
                `&start_date=${start_date}` +
                `&end_date=${end_date}`
            );
        }
    }
}
</script>

<style scoped>

</style>
